module.exports = __webpack_public_path__ + "assets/img/Groups973.23b09990.png";